<template>
  <div id="acChargeDetail">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ basicinfo.deviceTypeT }}</span><!--设备类型-->
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}: V{{ basicinfo.fwVersion }}</span><!--固件-->
      </div>
    </el-row>
    <!-- 时间 -->
    <el-row class="content">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- <p class="blockTitleP" style="padding-top: 0;padding-left: 0;">
          <i class="el-icon-time" style="font-size: 24px;" />
          <span style="vertical-align: text-bottom;"> {{ timeAgo }}</span>
        </p> -->
        <p class="contentTitle">
          <i class="el-icon-time" style="font-size: 24px;vertical-align: top; margin-top: -5px;" />
          <span style="vertical-align: text-bottom;"> {{ timeAgo }}</span>
          <!-- <el-button v-show="editTable" type="primary" style="vertical-align: top;margin-top: 7px;float: right;margin-left: 10px;" @click="tableSubmit('charging')">提交</el-button> -->
          <!-- <el-button v-show="editBtn" type="primary" style="vertical-align: top;margin-top: 7px;float: right;margin-left: 10px;" @click="edit">编辑</el-button>
          <el-button v-show="closeBtn" type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="close">取消</el-button>
          <el-button v-show="viewBtn=='close'" type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="clickSet('close')">收起配置</el-button>
          <el-button v-show="viewBtn=='open'" type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="clickSet('open')">配置</el-button> -->
        </p>
        <inverterSetTem />
      </el-col>
      <!-- <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
        <span style="margin-left: 10%;">AC OUT</span>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col" style="text-align: right;">
        <span style="margin-right: 10%;">DC SYSTEM</span>
      </el-col> -->
    </el-row>
    <!-- 中间内容区 -->
    <el-row class="middleContentWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col middleContent">
        <!-- 电器 -->
        <div class="electricalWarp">
          <div>
            <p style="margin-bottom: 5px;text-align: center;">AC OUTPUT</p>
            <p style="margin-bottom: 5px;text-align: center;">to Load</p>
            <img v-if="isAllOn" src="@/assets/images/electrical_online.png" alt="">
            <img v-if="!isAllOn" src="@/assets/images/electrical_offline.png" alt="">
          </div>
          <div class="infoVorA">
            <img src="@/assets/images/battery/vsBlack.png" alt="">
            <span>{{ inverterData.electricalV }} V</span>
          </div>
        </div>
        <!-- 箭头 -->
        <div class="arrowBox">
          <div class="soildLine" :class="{'dottedLine':!isAllOn}" />
          <div v-if="isAllOn" class="blueDeltaLeft" />
          <div class="infoVorA">
            <img src="@/assets/images/battery/asBlack.png" alt="">
            <span>{{ inverterData.arrowA1 }} A</span>
          </div>
        </div>
        <!-- 单项逆变器 -->
        <div class="inverterWarp">
          <div class="temInfo">
            <img src="@/assets/images/tem_black.png" alt="" style="height: 40px;">
            <span>{{ inverterData.inverterTem }}℃</span>
          </div>
          <p style="margin-bottom: 5px;text-align: center;">{{ inverterData.machineModel }}</p>
          <img v-if="isAllOn" src="@/assets/images/inverter_online.png" alt="" class="inverterImg">
          <img v-if="!isAllOn" src="@/assets/images/inverter_offline.png" alt="" class="inverterImg">
          <img v-if="isShowWarning" src="@/assets/images/warningIcon.png" alt="" class="warningIcon">
          <p>DISCHARGED</p>
        </div>
        <!-- 箭头 -->
        <div class="arrowBox">
          <div class="soildLine" :class="{'dottedLine':!isAllOn}" />
          <div v-if="isAllOn" class="blueDeltaLeft" />
          <div class="infoVorA">
            <img src="@/assets/images/battery/aBlack.png" alt="">
            <span>{{ inverterData.arrowA2 }} A</span>
          </div>
        </div>
        <!-- 电池组 -->
        <div class="cellTeamWarp">
          <div>
            <p style="margin-bottom: 5px;text-align: center;">12V DEEP CYCLE</p>
            <p style="margin-bottom: 5px;text-align: center;">HOUSE BATTERY</p>
            <img v-if="isAllOn" src="@/assets/images/cellTeam_online.png" alt="">
            <img v-if="!isAllOn" src="@/assets/images/cellTeam_offline.png" alt="">
          </div>
          <div class="infoVorA">
            <img src="@/assets/images/battery/vBlack.png" alt="">
            <span>{{ inverterData.cellTeam }} V</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 警告区 -->
    <el-row class="warningWarp">
      <el-col :xs="12" :sm="12" :lg="12" class="card-panel-col">
        <div v-if="isShowWarning">
          <div class="warningImgAndP">
            <!-- <img src="@/assets/images/warningSimpleImg/E01.png" alt=""> -->
            <img :src="warningImg.imgUrl">
            <span>{{ question }}</span>
          </div>
          <div class="warningP">
            <span>{{ answer }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { findDeviceInfo, setCBBCfg, getCBBCfg } from '@/api/bidirectional'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'
import inverterSetTem from '@/views/inverter/inverterSetTem'

export default {
  name: 'Bidirectional',
  components: {
    inverterSetTem
  },
  data() {
    return {
      basicinfo: {},
      isAllOn: true, // 是否在线
      yhubmqtt: {}, // MQTT值
      inverterMqttData: {}, // 来自MQTT的acCharge的值
      inverterData: {// ac充电器数据
        electricalV: '--',
        arrowA1: '--',
        inverterTem: '--',
        arrowA2: '--',
        cellTeamV: '--'
      },
      isShowWarning: false,
      warningImg: { imgUrl: require('@/assets/images/warningSimpleImg/E01.png') }, // 警告--图片
      question: 'When unit is in Battery/Inverter mode, Input battery voltage is too low and AC Output is shutdown.', // 警告--wenti
      answer: 'Recharge the battery immediately and restart unit.', // 警告--答案
      warningInfo: [// 警告文字
        { key: 'A01', question: 'Temperature Sensor (BTS) is defective.', answer: 'Check and or replace the sensor.' },
        { key: 'E01', question: 'Unit shutdown due to low AC Input(< 85 +/- 5Vac)', answer: 'Check AC input source. The unit will automatically recover when the AC Input voltage return to > 108 +/-5Vac' },
        { key: 'E02', question: 'Unit shutdown due to high AC Input(>270 +/- 5Vac)', answer: 'Check AC input source. The unit will automatically recover when the AC Input voltage return to < 260 +/-5Vac' },
        { key: 'E03', question: 'Battery is connected backwards', answer: 'Check all battery connections' },
        { key: 'E04', question: 'Charger Internal temperature is too high and it has to shut down. The unit will automatically recover when the unit cools down.', answer: 'The ventilation of the unit is blocked or the environmental temperature is high. Reduce charging current or improve the ventilation near the unit.' },
        { key: 'E05', question: 'Not used.', answer: '' },
        { key: 'E06', question: 'High battery temperature >70 °C (158°C) is sensed by the BTS. The unit will shut down. The unit will automatically recover when the battery temperature has reduced to 60°C (140°F).', answer: 'Check the battery, charger setting, and its environment.' },
        { key: 'E07', question: 'Low battery temperature < -25°C (-13°F) is sensed by the BTS. The unit will shut down. The unit will automatically recover when battery temperature reaches -20°C (-4°F).', answer: 'It is not recommended to charge the battery at extremely low temperatures.' },
        { key: 'E08', question: 'DC Output fuses are brown.', answer: 'Check battery connection and replace the fuse with the same type and rating.' },
        { key: 'E09', question: 'Unit shutdown due to high battery voltage (> 17 Vdc on 12V model and >34 Vdc on 24V model). The unit will automatically recover when battery Voltage reduced to <16Vdc on 12V model or <32 Vdc on 24V model.', answer: 'Check battery and charger setting. Check also if there is any other DC supply connected to the battery banks.' }
      ],

      timeAgo: '',
      timeAgoRST: '',
      timer: null
    }
  },
  computed: {
    storeYhubmqtt() {
      return this.$store.state.yhubmqtt// 需要监听的数据
    }
  },
  watch: {
    storeYhubmqtt: {
      handler(newValue, oldValue) {
        this.yhubmqtt = newValue // 把新值赋值给我们的属性数据
        // console.log(this.yhubmqtt)
        // console.log(this.yhubmqtt.payload)
        this.MQTT()
      },
      deep: true
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      // 设备信息
      findDeviceInfo(param).then(res => {
        // 设备信息详情
        this.basicinfo = res.resultModel
        this.basicinfo.deviceTypeT = this.$route.query.deviceTypeT
      })
    },
    change(e) {
      this.$forceUpdate()
    },
    MQTT() {
      if (this.yhubmqtt) {
        // this.$route.query.mcuId = '05d6ff393430475043165127'
        if (!this.yhubmqtt.topic || this.yhubmqtt.topic.indexOf(this.$route.query.mcuId) == -1) return
        console.log('yhubmqtt-----', this.yhubmqtt)
        if (this.yhubmqtt.payload === 'mCan') {
          if (!this.yhubmqtt.mCan) return
          if (this.yhubmqtt.mCan.payload && this.yhubmqtt.mCan.payload === 'mCBBRealTimeData') {
            var cbbMqttData = this.yhubmqtt.mCan.mCBBRealTimeData
            console.log('mCBBRealTimeData-----', cbbMqttData)
            // this.dcdcMqttData = mCanData.mDMTRealTimeData // 实时详情、警告
            // console.log('this.dcdcMqttData---', this.dcdcMqttData)
            if (!cbbMqttData) return
            if (cbbMqttData) {
              this.inverterData.electricalV = cbbMqttData.inverter_V / 100
              this.inverterData.arrowA1 = cbbMqttData.inverter_I / 100
              // this.inverterData.inverterTem = cbbMqttData.inverter_V
              // this.inverterData.machineModel = cbbMqttData.aa
              this.inverterData.arrowA2 = cbbMqttData.bat_I / 100
              this.inverterData.cellTeam = cbbMqttData.bat_V / 100
            }
          }
        }
        //   console.log('this.yhubmqtt---', this.yhubmqtt.mCan)
        //     this.inverterMqttData = this.yhubmqtt.mCan.mInverterData // 实时详情、警告
        //     console.log('this.inverterMqttData---', this.inverterMqttData)
        //     if (!this.inverterMqttData) return
        //     if (this.inverterMqttData) {
        //       this.timeAgo = i18n.t('dataAndTime.AMomentAgo')
        //       this.timeAgoRST = new Date().getTime()
        //       if (this.inverterMqttData.connection === 1) { // 设备状态 1：连接 0：断开
        //         this.isAllOn = true
        //       } else {
        //         this.isAllOn = false
        //       }
        //       if (this.inverterMqttData.AC_V) this.inverterData.plugV = this.inverterMqttData.AC_V > 100 ? this.inverterMqttData.AC_V / 100 : this.inverterMqttData.AC_V
        //       if (this.inverterMqttData.envTemp) this.inverterData.inverterTem = this.inverterMqttData.envTemp > 100 ? Math.round(this.inverterMqttData.envTemp / 100) : this.inverterMqttData.envTemp
        //       if (this.inverterMqttData.CH1_V) this.inverterData.cellTeamV1 = this.inverterMqttData.CH1_V / 100
        //       if (this.inverterMqttData.CH2_V) this.inverterData.cellTeamV2 = this.inverterMqttData.CH2_V / 100
        //       if (this.inverterMqttData.CH3_V) this.inverterData.cellTeamV3 = this.inverterMqttData.CH3_V / 100
        //       if (this.inverterMqttData.errorCode) this.isShowWarning = true
        //       var batConnectedArr = []
        //       if (this.inverterMqttData.batConnected) {
        //         batConnectedArr = this.decimalToBinary(this.inverterMqttData.batConnected)
        //         if (batConnectedArr[0] == 1) {
        //           this.isCellTeamOn1 = true
        //           if (this.inverterMqttData.charge_I) this.inverterData.cellTeamA1 = this.inverterMqttData.charge_I / 100
        //         }
        //         if (batConnectedArr[1] == 1) {
        //           this.isCellTeamOn1 = true
        //           if (this.inverterMqttData.charge_I) this.inverterData.cellTeamA2 = this.inverterMqttData.charge_I / 100
        //         }
        //         if (batConnectedArr[2] == 1) {
        //           this.isCellTeamOn1 = true
        //           if (this.inverterMqttData.charge_I) this.inverterData.cellTeamA3 = this.inverterMqttData.charge_I / 100
        //         }
        //       }
        //     }
        //   }
        // }
      }
    },
    setTimer() { // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgoRST) { this.timeAgo = howLongAgo(this.timeAgoRST) }
        }, 600)
      }
    },
    getBit(n, k) {
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    },
    decimalToBinary(num) { // 十进制转二进制
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (myNum < 10) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      } else if (myNum >= 10 && myNum < 100) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
.card-panel{
  padding-bottom: 20px;
}
#acChargeDetail{
  .contentTitle{
    height:50px;
    line-height:50px;
    border-bottom: 2px solid #e6e9ed;
    font-weight: bold;
  }
  .content{
    background:white;
    margin-top: 32px;
    padding: 20px;
  }
  .infoVorA{
    text-align: center;
  }
  .infoVorA img{
    width:30px;
  }
  .infoVorA span{
    line-height: 30px;
    vertical-align: top;
  }
  .electricalWarp div:nth-of-type(1) img{
    width:120px;
  }
  .inverterWarp{
    position: relative;
  }
  .inverterWarp>img{
    width:200px;
  }
  .inverterWarp>p{
    text-align: center;
  }
  .cellTeamWarp div:nth-of-type(1) img{
    width:180px
  }
  .middleContentWarp{
    padding:0 5%;
    // border:1px solid red;
    // height: 500px;
    width: 100%;
    background: white;
    padding-top: 20px;
  }
  .middleContent{
    height: 300px;
    // border:1px solid red;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .soildLine{
    width:100px;
    border-top:3px solid #1990fc;
  }
  .dottedLine{
    border-top: 3px dotted #e3e3e3;
  }
  .blueDeltaLeft{//向右三角形
    width: 0;
    height: 0;
    border-right: 15px solid #1990fc;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    margin-top: -12px;
    margin-left: -3px;
  }
  .temInfo{
    display: flex;
    align-items: center;
    position: absolute;
    right: 20px;
    top: -40px;
  }
  .warningIcon{
    width: 20px!important;
    position:absolute;
    top: -10px;
    left: 15px;
  }
  .warningWarp{
    background:white;
    padding: 0px 5%;
    display: inline-block;
    width:100%;
    padding-bottom: 30px;
  }
  .warningWarp img{
    width: 50px;
  }
  .warningWarp .warningImgAndP{
    display: flex;
    align-items: center;
  }
  .warningWarp .warningImgAndP span{
    margin-left: 10px;
    color: red;
  }
  .warningWarp .warningP{
    margin-top: 10px;
    color: blue;
  }
}
</style>

